module.exports = __webpack_public_path__ + "img/20.154838ce.jpg";